import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { rem } from 'polished'
import type { ComponentProps } from 'react'
import React from 'react'
import styled from 'styled-components'

const Container = styled(ClickableListItem)`
  background-color: transparent;
  padding-inline: ${rem(8)};
`

interface Props extends Omit<ComponentProps<typeof ClickableListItem>, 'size'> {
}

function FooterListItem(props: Props) {
  return <Container {...props} size="medium" />
}

export default FooterListItem
